import { type ReactNode } from 'react';
import { Paper, Stack, Typography } from '@mui/material';

type Props = {
    title: string;
    children: ReactNode;
};

/*
    One section of the course editor. The card owns its internal padding; the page owns the space
    between cards.

    The Stack below zeroes the margin on every direct child at a specificity sx cannot beat, so a
    child that needs space of its own uses padding.
*/
export default function EditorCard({ title, children }: Props) {
    return (
        <Paper sx={{ padding: 3 }}>
            <Stack spacing={3}>
                <Typography variant="h6">{title}</Typography>
                {children}
            </Stack>
        </Paper>
    );
}
